import store from '../store/store';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('setIsSaving', function setIsRemovingDomain(newValue: boolean) {
    store.domainState.isRemovingDomain = newValue;
    store.domainState.isDomainRemoved = true;
});
